import React from "react";
import {
  Box,
  Typography,
  Grid,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { motion } from "framer-motion";

const PartsBenefits = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Box
      sx={{
        background: "#004aad",
        px: { xs: 2, md: 4 },
        py: { xs: 4, md: 8 },
      }}
    >
      <Grid container spacing={4} alignItems="center" justifyContent="center">
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              maxWidth: "500px",
              mx: "auto",
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { xs: "1.5rem", sm: "1.8rem", md: "2.3rem" },
                fontWeight: "bold",
                color: "#fff",
                mb: 2,
              }}
            >
              ¡Descubre los beneficios de comprar en HYDROLUZ!
            </Typography>

            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: "1rem", sm: "1.125rem", md: "1.25rem" },
                color: "#fff",
                textAlign: "justify",
                lineHeight: 1.8,
                mb: 3,
              }}
            >
              Regístrate ahora en <strong>HYDROLUZ</strong> y accede a una variedad
              de productos únicos, promociones exclusivas y atención
              personalizada. Al ser parte de nuestra comunidad, podrás disfrutar
              de descuentos especiales y novedades cada semana.
            </Typography>

            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              whileInView={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.2 }}
              viewport={{ once: true, amount: 0.3 }}
            >
              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#ffcc00",
                  color: "#0a2a5e",
                  fontSize: { xs: "0.8rem", sm: "1rem" },
                  fontWeight: "bold",
                  borderRadius: "30px",
                  px: 4,
                  py: 1.5,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
                  "&:hover": {
                    backgroundColor: "#ffd633",
                    color: "#000",
                  },
                }}
                href="/registro"
              >
                CREAR CUENTA
              </Button>
            </motion.div>
          </Box>
        </Grid>

        <Grid item xs={12} md={6} display="flex" justifyContent="center">
          <motion.img
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, amount: 0.3 }}
            src={require("../../static/media/home/register.webp")}
            alt="Productos disponibles en HYDROLUZ"
            style={{
              width: isMobile ? "80%" : "100%",
              height: "auto",
              maxWidth: isMobile ? "300px" : "500px",
              maxHeight: isMobile ? "270px" : "400px",
              objectFit: "contain",
              display: "block",
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default PartsBenefits;
